import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ShieldCheck, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-bank-statement/verify`;
const LOGO = `${process.env.REACT_APP_BACKEND_URL}/api/token-list/beth-usd.png`;
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const Row = ({ k, v, testid }) => (<div className="flex justify-between gap-4 py-2 border-b border-slate-700 text-sm"><span className="text-slate-400">{k}</span><span className="text-white font-medium text-right" data-testid={testid}>{v}</span></div>);

export default function VerifyStatement() {
  const { documentId } = useParams();
  const [params] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    axios.get(`${API}/${documentId}`, { params: { t: params.get('t') || '' } }).then(r => setD(r.data)).catch(e => setErr(e.response?.data?.detail || 'Could not verify this statement'));
  }, [documentId, params]);
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="verify-statement-page">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md w-full">
        <div className="flex items-center gap-3 mb-6"><img src={LOGO} alt="BETH USD" className="w-10 h-10 rounded-full" /><span className="font-bold text-white">BETHCOIN Statement Verification</span></div>
        {err ? <p className="flex items-center gap-2 text-red-400 font-semibold" data-testid="verify-statement-error"><XCircle className="w-6 h-6" /> {err}</p>
          : !d ? <p className="text-slate-400">Verifying…</p> : (
            <>
              <p className="flex items-center gap-2 text-emerald-400 text-xl font-bold mb-4" data-testid="verify-statement-genuine"><ShieldCheck className="w-7 h-7" /> Genuine statement</p>
              <Row k="Issued by" v={d.issuer} />
              <Row k="Account holder" v={d.holder_name} testid="verify-statement-holder" />
              <Row k="Account" v={`••••${d.account_last4}`} testid="verify-statement-account" />
              <Row k="Statement month" v={new Date(`${d.month}-01T00:00:00`).toLocaleDateString(undefined, { month: 'long', year: 'numeric' })} testid="verify-statement-month" />
              <Row k="Closing balance" v={money(d.closing_balance)} testid="verify-statement-closing" />
              <Row k="Document ID" v={<span className="font-mono text-xs">{d.document_id}</span>} testid="verify-statement-docid" />
              <p className="text-xs text-slate-500 mt-4">Figures reflect the statement as last generated on {new Date(d.generated_at).toLocaleString()}.</p>
            </>
          )}
      </div>
    </div>
  );
}
